import React from 'react';
import BookingResultPanel from 'src/components/views/widget/BookingResultPanel';

const BookBeachChairResultPage: React.FC = () => {
    return <BookingResultPanel />;
};

export default BookBeachChairResultPage;
